export function sumEmissionDicts(...dicts: { [year: string]: number | undefined }[]): {
  [year: string]: number | undefined;
} {
  return dicts.reduce((acc, dict) => {
    Object.keys(dict).forEach((year) => {
      if (dict[year] !== undefined) {
        acc[year] = (acc[year] || 0) + dict[year]!;
      }
    });
    return acc;
  });
}
